<template>
  <div
    v-if="
    !isLoading &&
    contentType === 'onair' &&
    (isError || !hasVodList)"
    class="vod-list-empty"
  >
    <img :src="require('@/assets/images/common/icon-error-74.png')" alt="에러 아이콘">
    <p>본 프로그램은 Quick VOD만 제공됩니다.</p>
  </div>

  <div
    v-else-if="hasVodList"
    class="player-component01"
  >
    <div id="all" :class="['player-list', { 'loading': isLoading }]">
      <div class="filter-box">
        <button type="button" class="button" @click="changeFilterToggle()">{{ filterText(orderData) }}</button>
      </div>
      <!-- 전체회차 썸네일 리스트 -->
      <ul v-if="!isLoading" class="episode-list">
        <ThumbAllVod
          v-for="(thumb, index) in vodList"
          :key="`episode_list_vod_${index}`"
          :thumb="thumb"
          :external-content-id="contentInfo.contentid"
          :change-content="changeContent"
          :is-pooqzone="isPooqzone"
          :thumbnail-info="thumbnailInfo"
        />
        <li v-if="isOdd" class="vod-all-list-item" aria-hidden="true">&nbsp;</li>
      </ul>
    </div>
    <!-- 페이징 -->
    <PagingComponent
      :current-page="currentPage"
      :page-count="pageCount"
      :limit="limit"
      :paging-count="10"
      :is-next-button-view="isNextButtonView"
    />
  </div>
</template>
<script>
import _ from 'lodash'
import ThumbAllVod from '@/components/model/ThumbAllVod'
import PagingComponent from '@/components/common/PagingComponent'
import { getVodEpisodeList } from '@/common/utils/request'
import cookie from '@/common/utils/cookie'
import { parseUrl, stringify } from 'query-string'
import { getThumbnailInfo } from '@/common/utils/common'
import { PATH_NAME_PLAYER_STREAM } from '@/common/resources/router.const'

export default {
  name: 'EpisodeContentList',
  components: {
    ThumbAllVod,
    PagingComponent
  },
  props: {
    contentInfo: {
      type: Object,
      default: () => ({}),
      required: true
    },
    landingInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      vodList: [],
      isPooqzone: cookie.isWavveOn(),
      currentPage: 1,
      pageCount: 0,
      limit: 10,
      isError: false,
      orderData: '',
      isNextButtonView: false,
      isLoading: true,
      thumbnailInfo: {},
      isOdd: false
    }
  },
  computed: {
    contentType () {
      return _.get(this.contentInfo, 'type', '')
    },
    hasVodList () {
      return this.vodList.length !== 0
    },
    page () {
      return Number(_.get(this.$route, ['query', 'page'], '1'))
    }
  },
  methods: {
    // 전체 BROADCAST 데이터를 API로 가져온다.
    async callApi (page) {
      this.isLoading = true
      const { landing_list: landingList = {}, programid = '' } = this.landingInfo
      const offset = this.limit * (page - 1)
      const [ episodeTab ] = landingList.tab.filter(tab => tab?.type === 'episode')
      const episodeTabPath = episodeTab?.path.replace('/fz', '') || ''
      const { url, query } = parseUrl(episodeTabPath)

      this.orderData = this.$route.query.orderby || query?.orderby

      try {
        const { data: contentsRes } = await getVodEpisodeList({ path: url, limit: this.limit, offset, orderby: this.orderData, programid: programid })
        const { data: nextContentsRes } = await getVodEpisodeList({ path: url, offset: Math.ceil(page / 10) * 100, limit: this.limit, orderby: this.orderData, programid: programid })

        const listCount = _.get(nextContentsRes, 'cell_toplist.celllist', []).length
        this.vodList = _.get(contentsRes, 'cell_toplist.celllist', [])
        this.isOdd = (this.vodList.length % 2) === 1
        this.isNextButtonView = listCount > 0
        this.pageCount = Number(_.get(contentsRes, 'cell_toplist.pagecount', '0'))
        this.thumbnailInfo = getThumbnailInfo(_.get(contentsRes, 'cell_toplist.cell_type', ''))
        this.isLoading = false
        this.currentPage = page
      } catch (e) {
        this.isLoading = false
        this.$events.$emit('OPEN_PPV_TOAST', () => {}, '에피소드 리스트를 가져오지 못했습니다.')
      }
    },
    changeContent (thumb) {
      const { contentid = '' } = thumb

      this.$router.push({
        name: PATH_NAME_PLAYER_STREAM,
        params: { section: 'vod' },
        query: { contentid: contentid }
      })
    },
    changedQueryRouterReplace (changedQueryObj) {
      const currentQuery = _.get(this.$route, 'query', {})
      const newQuery = _.assign({}, currentQuery, changedQueryObj)
      this.$router.replace(`vod?${stringify(newQuery)}`)
    },
    changeFilterToggle () {
      this.orderData = (this.orderData === 'new') ? 'old' : 'new'
      this.filterText(this.orderData)
      this.offset = 0
      this.limit = 10
      this.currentPage = 1
      this.changedQueryRouterReplace({ orderby: this.orderData, page: this.currentPage })
    },
    filterText (order) {
      return order === 'new' ? '최신순' : '오래된순'
    }
  },
  created () {
    this.currentPage = Number(this.$route.query?.page || '1')
  },
  mounted () {
    this.callApi(this.currentPage)
  }
}
</script>
<style lang="scss" scoped>
.player-list {
  &.loading {
    min-height: 1159px;
  }
}
</style>
